import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const editUserEmailFormSchema = yup
  .object()
  .shape({
    currentUserEmail: yup.string().trim().email().required(),
    newUserEmail: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .email()
      .required()
      .label("Email")
      .notOneOf(
        [yup.ref("currentUserEmail")],
        "New email must be different from the current one"
      ),
  })
  .required();

export type EditUserEmailFormSchema =
  typeof editUserEmailFormSchema.__outputType;
